import moment from "moment";
export const  formatValidDate = (date) => {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format("DD-MM-YYYY") : null;
  };